import styles from 'src/components/Reviews/reviews.module.scss';
import ReviewsCard, { Review } from './RewiewsCard';
import classNames from 'classnames';

type ReviewsProps = {
    reviews: Review[];
};

const Reviews = ({ reviews }: ReviewsProps) => (
    <div
        className={classNames(styles['reviews-wrapper'], 'overflow-auto')}
        data-reviews-wrapper
    >
        <div
            className={classNames(
                styles['reviews-wrapper--scrollbar-track'],
                'flex overflow-x-auto space-x-4 snap-x snap-mandatory h-full pb-4 scroll-pr-4'
            )}
        >
            {reviews.map((review, index) => (
                <div
                    className={classNames(
                        'w-[90%] drop-shadow sm:w-2/3 xl:w-[40%] flex-shrink-0 bg-white py-8 px-4 text-center rounded-lg snap-always snap-start'
                    )}
                    key={index}
                >
                    <ReviewsCard review={review} />
                </div>
            ))}
        </div>
    </div>
);
export default Reviews;
